module.exports = __webpack_public_path__ + "img/region-middle-east-asia.c6867f91.png";